const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

export default {
  isEmailValid(email) {
    return (this.email === '') ? null : regex.test(email);
  },
  doesPasswordMeetRequirements(password) {
    const containsNumbers = (str) => /\d/.test(str);
    const containsUppercase = (str) => /[A-Z]/.test(str);
    const containsLowercase = (str) => /[a-z]/.test(str);
    const containsSpecialSymbol = (str) => /[\^$*.[\]{}()?\-"!@#%&/\\,>':;|_~`]/.test(str);
    return password && password.length > 7 && containsNumbers(password)
      && containsUppercase(password) && containsLowercase(password) && containsSpecialSymbol(password);
  },
};
